module.exports = __webpack_public_path__ + "static/img/icon_axqy.d53dc7af.png";